module.exports = __webpack_public_path__ + "media/julio_material_motion_new.a2bd6fed.mp4";